module.exports = __webpack_public_path__ + "resources/img/img_dsm1_en.421433083b9855fcf638d7af264c0896.png";